import React from 'react';
import { FaTruck, FaPlane, FaShip, FaBox, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import ShipmentTimeline from './ShipmentTimeline';


function ShipmentCard2({ shipment }) {
    let indicatorPosition = 'left-1/2'; // Default for "In Transit"

    if (shipment.status === "Created") {
        indicatorPosition = 'left-0 ml-2';
    } else if (shipment.status === "Delivered") {
        indicatorPosition = 'right-0 mr-2';
    }

    return (
        <div className="bg-white rounded-xl p-6 m-4 shadow-lg font-sans transition-transform transform hover:scale-105">



            <div className="flex justify-between items-center mb-4">
                <div>
                    <div className="text-gray-600 mb-1">Shipment Number</div>
                    <div className="text-black font-semibold text-xl">{shipment.shipmentNumber}</div>
                </div>
                <div className={`rounded-lg px-3 py-1 text-white font-bold text-sm ${shipment.statusColor} shadow-sm`}>{shipment.status}</div>
            </div>

            <div className="flex justify-between items-center mt-4">
                <div className="text-left">
                    <div className="text-gray-600 inline-flex items-center"><FaMapMarkerAlt className="mr-2 text-xl" />Origin</div>
                    <div className="font-medium mt-1">{shipment.origin}</div>
                </div>

                <div className="relative flex-grow mx-2">
                    <div className="absolute center-y left-0 right-0 h-1 bg-gray-300" style={{ top: '50%', transform: 'translateY(-50%)' }}></div>
                    <div className={`w-6 h-6 rounded-full bg-yellow-500 absolute top-1/2 transform -translate-y-1/2 ${indicatorPosition} shadow-sm`}></div>
                </div>

                <div className="text-right">
                    <div className="text-gray-600">Destination</div>
                    <div className="font-medium mt-1">{shipment.destination}</div>
                </div>
            </div>

            <div className="mt-4 border-t border-gray-300 pt-4">
                <div className="text-gray-600 flex items-center mb-2"><FaBox className="mr-2 text-xl" />Shipper</div>
                <div className="font-medium mb-2">{shipment.shipper}</div>

                <div className="text-gray-600 mt-2">Consignee</div>
                <div className="font-medium">{shipment.consignee}</div>
            </div>

            <div className="mt-4 border-t border-gray-300 pt-4 grid grid-cols-2 gap-4">
                <div className="text-gray-600 flex items-center mb-2">
                    Modality
                    {shipment.modality === "AIR" && <FaPlane className="text-yellow-500 ml-2 text-xl" />}
                    {shipment.modality === "GROUND" && <FaTruck className="text-yellow-500 ml-2 text-xl" />}
                    {shipment.modality === "SEA" && <FaShip className="text-yellow-500 ml-2 text-xl" />}
                </div>
                <div className="font-medium mb-2 rounded-lg px-3 py-1 bg-yellow-500 text-white shadow-sm">{shipment.modality}</div>

                <div className="text-gray-600 mb-2">Service Type</div>
                <div className="font-medium mb-2">{shipment.serviceType}</div>

                <div className="text-gray-600 mb-2">Customer Reference</div>
                <div className="font-medium mb-2">{shipment.customerReference}</div>

                <div className="text-gray-600 flex items-center mb-2"><FaCalendarAlt className="mr-2 text-xl" />Estimated Departure</div>
                <div className="font-medium mb-2">{shipment.estimatedDeparture}</div>

                <div className="text-gray-600 mb-2">Estimated Arrival</div>
                <div className="font-medium mb-2">{shipment.estimatedArrival}</div>

                <div className="text-gray-600 mb-2">New Estimated Arrival</div>
                <div className="font-medium">{shipment.newEstimatedArrival}</div>
            </div>

            <div className="mt-4 border-t border-gray-300 pt-4">
                <div className="text-gray-600 mb-2">Package Type</div>
                <div className="font-medium">{shipment.packageQuantity}x {shipment.packageType}</div>
            </div>

            <div className="mt-4 w-full">
                <div className="flex flex-col items-stretch p-0 m-0">
                    <ShipmentTimeline currentStatus={shipment.detailedStatus} />
                </div>
            </div>

        </div>

    );
}

export default ShipmentCard2;
